import { render } from "./CardSalaVirtual.vue?vue&type=template&id=77156b9e"
import script from "./CardSalaVirtual.vue?vue&type=script&lang=js"
export * from "./CardSalaVirtual.vue?vue&type=script&lang=js"

import exportComponent from "/Users/rhylton/Sites/intranet/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__